import React from 'react'
import { AuthTemplateView } from '~/components'
import { CircularProgress } from '@material-ui/core'

export const ResetLoading: React.FC = () => {
  return (
    <AuthTemplateView hideLinkToCreateNewAccount>
      <CircularProgress
        size={64}
        color='secondary'
        sx={{
          position: 'relative',
          top: 'calc((50% - 64px) / 2)',
          left: 'calc((100% - 64px) / 2)'
        }}
      />
    </AuthTemplateView>
  )
}
